export default __webpack_public_path__ + "static/media/example_capsulte.bf5c49fd.png";